import { ValidatorRule } from './validation.interfaces';

export abstract class ValidatorRuleBase<TMetadata> implements ValidatorRule {
  private _isValid = true;
  get isValid(): boolean {
    return this._isValid;
  }

  private _hasValidated = false;
  get hasValidated(): boolean {
    return this._hasValidated;
  }

  private stateChangedCallbacks: ((rule: ValidatorRule) => void)[] = [];
  onStateChanged(callback: (rule: ValidatorRule) => void): () => void {
    this.stateChangedCallbacks.push(callback);

    let detachHandler = () => {
      let callbackIndex = this.stateChangedCallbacks.indexOf(callback);
      if (callbackIndex == -1) return;
      this.stateChangedCallbacks.splice(callbackIndex, 1);
    };
    return detachHandler;
  }

  constructor(
    public readonly key: string,
    public readonly metadata: TMetadata,
  ) {}

  validate(): boolean {
    this._hasValidated = true;
    let isValid = this.doValidate();
    this.setIsValidState(isValid);
    return isValid;
  }

  protected abstract doValidate(): boolean;

  private setIsValidState(isValidState: boolean) {
    if (this._isValid == isValidState) return;
    this._isValid = isValidState;

    // Raise the callbacks
    for (let stateChangeCallback of this.stateChangedCallbacks) {
      stateChangeCallback(this);
    }
  }
}
